import { Bookmark } from '@material-ui/icons';

export const en = {
  analyzed_influencers: 'analyzed influencers',
  un_analyzed_influencers: 'un analyzed influencers',
  total_categories: 'total categories',
  total_subca: 'Total Subcategories',
  subcategory: 'Subcategory',
  total_tweets: 'total tweets',
  total_groups: 'total groups',
  new_influencers: 'new influencers',
  influencerGroup: 'influencers / group',
  influencer_category: 'influencers category',
  influencer_platform: 'influencers / platform',
  influencer_age_group: 'influencers age group',
  Top_5_trending_influencers: 'top 5 trending influencers',
  influencers_gender: 'influencers gender',
  platforms: 'Platforms',
  categories: 'categories',
  inf_groups: ' influencers groups',
  inf_category: 'influencers categories',
  influencers: 'influencers',
  tweets: 'tweets',
  groups: 'groups',
  most_popular_videos: 'Most Popular videos',
  most_popular_posts: 'Most Popular posts',
  most_popular_tweets: 'Popular tweets of',
  search_by_title: 'search by Title',
  total_influencers: 'total influencers',
  influencers_map: 'influencers map',
  new_influencer: 'new influencer',
  grabbed_on: 'grabbed on',
  group_name: 'group name',
  num_influencers: 'NO. of influencers',
  num_entities: 'NO. of Entities',
  num_subCategories: 'NO. of subcategories',
  slug: 'Slug',
  created_group: 'created group',
  influencers_group: 'influencers group',
  add_new_group: 'add new group',
  created_categories: 'created categories',
  Subcategory_category: 'subcategory/category',
  category_name: 'category name',
  analyzed_influencers_details: 'analyzed influencers details',
  total_followers: 'total followers',
  general_info: 'general information',
  general_skills: 'General Skills',
  name: 'name',
  nickname: 'nickname',
  age: 'age',
  country: 'country',
  personal_info: 'personal information',
  gender: 'gender',
  social_status: 'social status',
  religion: 'religion',
  address: 'address',
  tweet_clients: 'Tweet Clients',
  email: 'email',
  emails: 'emails',
  website: 'website',
  websites: 'websites',
  related_influencers: 'Related Influencers',
  phone_numbers: 'phone numbers',
  still_working_there: ' Still Working There ',
  phone_number_error: 'phone number must be filled and be in range 9-15 digits',
  unique_name: 'influencer name must be unique',
  unique_link: 'social link must be unique',
  unique_phone_number: 'phone number must be unique',
  unique_address: 'address must be unique',
  unique_email: 'email must be unique',
  unique_website: 'website must be unique',
  good_friends: 'Good friends map',
  avg_paid: 'average paid',
  educational_info: 'educational information',
  school: 'school',
  university: 'university',
  school_university: 'School/University',
  degree: 'degree',
  grad_year: 'graduation year',
  work_info: 'work information',
  workplace: 'workplace',
  position: 'position',
  start_date: 'start date',
  end_date: 'end date',
  social_profile_urls: 'social profile urls',
  partnership_info: 'partnership information',
  in_part_with: 'in part with',
  extra_info: 'extra information',
  channel_sub: 'channels subscribers',
  uploaded_video: 'uploaded videos',
  total_videos_view: 'total videos view',
  add_new_influencer: 'add new influencer',
  edit_influencer: 'edit influencer',
  add_new_category: 'add new category',
  work_experience: 'Work experiences',
  social_links: 'social links',
  personal_photos: 'personal photos',
  additional_info: 'additional information',
  last_post: 'last post',
  partnerships: 'partnerships',
  category_info: 'category information',
  attach_influencers: 'attach influencer',
  attach_categories: 'attach categories',
  group_info: 'group information',
  searchBy_influencerTitle: 'search influencer',
  created_date: 'Created date',
  analyzed_category_to_influencer: 'analyzed category to influencer',
  analyzed_group_to_influencer: 'analyzed group to influencer',
  channel_subscribers: 'Channel Subscribers',
  total_views: 'Total videos views',
  views_per_day: 'Views per day',
  channel_watch_time: 'channel watch time',
  videos_calendar: 'Videos calendar',
  future_subscribers: 'Future Subscribers',
  related_hashtags: 'related hashtags',
  hiding_followers:'This influencer is hiding the followers list',
  hiding_followings:'This influencer is hiding the following list',
  similar_hashtags: 'similar hashtags',
  future_views: 'Future Views',
  channel_top_videos: 'channel top videos',
  related_influencers: 'related influencers',
  related_channels: 'related channels',
  similar_channels: 'Similar channels',
  similar_accounts: 'similar accounts',
  related_groups: 'related groups',
  influencer_no_tweets: 'No More Tweets, You have seen  all',
  influencer_no_posts_insta: 'No More Posts, You have seen  all',
  influencer_no_posts: 'No More Posts, You have seen  all',
  influencer_no_comments: 'No More Comments, You have seen  all',
  influencer_no_tiktok: 'No More videos, You have seen  all',
  add_skill: 'add skill',
  search_by_skill: 'search by skill',
  no_posts: 'No More Posts, You have seen all',
  no_articles: 'No More Posts, You have seen all',
  influencer_no_videos: 'No More Videos, You have seen  all',
  top_influencers: 'Top Influencers',
  edit_dashboard: 'Edit Dashboard',
  influencer_name: 'influencer name',
  nickname: 'nickname ',
  date_of_birth: 'date of birth',
  age_group: 'age group',
  change_picture: 'change picture',
  bio: 'Bio ',
  male: 'Male',
  female: 'Female',
  married: 'Married',
  relationship: 'In relationship',
  complicated: 'It’s Complicated',
  divorced: 'Divorced',
  single: 'single',
  phone_number: 'phone number',
  business_phone_number: 'business phone number',
  Add_another_phone_number: '+ Add another phone number',
  note:'note',
  Add_another_email: '+ Add another office email',
  Add_another_business_email: '+ Add another business email',
  Add_another_website: '+Add an another website',
  Add_another_business_address_number: '+Add another business address number',
  personal_address: 'personal address',
  gender: 'gender',
  Social_Status: 'Social Status',
  Religion: 'Religion',
  Average_paid: 'Average paid',
  website: 'website',
  degree: 'Degree',
  description: 'Description',
  Graduation_date: 'Graduation date',
  major: 'Major',
  faculty: 'Faculty',
  University: 'University',
  Graduation_date: 'Graduation date',
  school: 'School',
  trash: 'Trash',
  Add_another_school_section: '+ Add another school section',
  Add_another_college_section: '+ Add another college section',
  office_phone_number: 'Office phone number',
  Add_another_contact_section: '+ Add another contact Section',
  contact_info: 'contact information',
  office_email: 'Office email',
  business_email: 'business email',
  office_address: 'Office address',
  business_address: 'business address',
  office_fax_number: 'Office fax number',
  to: 'to',
  from: 'from',
  workplace: 'workplace',
  date: 'Date',
  Add_another_work_section: '+ Add another work section',
  At_least_one_field_is_to_be_filled:
    'You must add at least one valid social link',
  At_least_one_field_filled: 'At least one field must be filled',
  Partnership_name: 'Partnership name',
  Add_another_partnership_section: 'Add another partnership section',

  Add_field: 'Add field',
  value: 'value',
  key: 'Key',
  mentions: 'Mentions',
  hashtag: 'Hashtag',
  search_by_state: 'Search by state',
  search_by_city: 'Search by city',
  influencers_table: 'influencers table',
  Add_image: 'Add image',
  Catrgory_Name: 'Catrgory Name',
  Parent_Category: 'Parent Category',
  Videos_Archive: 'Videos Archive',
  grouping_table_here: 'grouping table here',
  attach_influnecer: 'Attach influnecer',
  influencer_importance: 'Influencer importance',
  entity_importance: 'Entity importance',
  are_you_sure_you_want_to_cancel: 'are you sure you want to cancel ?',
  search_by_influencer: 'search by influencer',
  search_by_category: 'search by category',
  category: 'category',
  gained_followers: 'Gained Followers',
  edit_category: 'edit category',
  edit_group: 'edit group',
  searchBy_influencersTitle: 'search By influencers Title',
  subscribers: 'subscribers',
  trashed_on: 'trashed on',
  category_subcategory: 'Category/Subcategory ',
  top_category_subcategory: 'Top Subcategories/Categories',
  tweet_types: 'Tweets Types',
  tweets: 'Tweets',
  top_people_in_conversation: 'Top people in conversation with',
  people_in_conversation: 'people in conversation with',
  frequent_used_hashtags: 'Frequently used hashtags',
  trending_hash_group: ' Trending hashtags to group',
  trending_hash_category: ' Trending hashtags to category',
  category_added_success: 'category added successfully',
  category_edited_success: 'Category Edited successfully',
  group_added_success: 'group added successfully',
  group_edited_success: 'group Edited successfully',
  edits_done_success: 'edits done successfully',
  influencer_group: 'influencer group',
  influencer_category_modal: 'influencer category',
  merge_inf:
    'Please choose one of the following merge option for Influencer name',
  exist_inf: 'Existing Influencer',
  new_inf: 'New Influencer',
  select_inf: 'Please select the existing influencer',
  select_new_inf: 'Please select the main influencer to grab name & photo from',
  assign_new_parent:
    'Are you Sure you want to assign new parent category? as all the categories that has parent category will be changed to the new parent',
  select_the_parent: 'please select the existing parent category',
  search_parent: 'search parent category',
  search_inf: 'search  influencer',
  added_successfully: 'Influencer Added Successfully',
  edited_successfully: 'Influencer Edited Successfully',
  videos: 'videos',
  merge_err: 'influencers have one or more social platform in common ',
  Videos_calendar: 'videos calendar',
  analyze: 'analyze',
  achievements: 'achievements',
  Up_to_Date: 'up to date',
  today: 'today',
  By_Month: 'by month',
  Popular: 'Popularity',
  Featuring: 'featuring',
  Featured_by: 'Featuring by',
  in_progress: 'in progress',
  completed: 'completed',
  archived: 'archived',
  achieved: 'achieved',
  video_archive: 'video archive',
  user: 'user',
  views: 'views',
  nationality: 'nationality',
  graduation_year: 'graduation year',
  see_more: 'see more',
  are_you_sure_you_want_to_cancel_edit_influencer:
    'Are you sure you want to cancel editing influencer?',
  are_you_sure_you_want_to_cancel_edit_group:
    'Are you sure you want to cancel editing group?',
  are_you_sure_you_want_to_cancel_add_group:
    'Are you sure you want to cancel adding group?',
  are_you_sure_you_want_to_cancel_add_category:
    'Are you sure you want to cancel adding category?',
  are_you_sure_you_want_to_cancel_edit_category:
    'Are you sure you want to cancel editing category?',
  are_you_sure_you_want_to_cancel_add_influencer:
    'Are you sure you want to cancel adding influencer?',
  see_less: 'see less',
  offic_fax_numb: 'office fax number',
  offic_phone_num: 'office phone number',
  continue: 'Continue',
  unanalyzed_influencers_details: ' unanalyzed influencer details',
  Created_date: 'Created date',
  likes: 'Like',
  posts: 'Posts',
  Talking_About: 'Talking About',
  Videos_calendar: 'Videos calendar',
  posts_types: 'posts types',
  Posts_per_day: 'Posts per day',
  Related_Hashtags: 'Related Hashtags',
  recent_media: 'recent media',
  Followers: 'Followers',
  Following: 'Following',
  Tweets: 'Tweets',
  average_interval_between_tweets: 'Average Interval between tweets',
  Most_active_time: 'Most active time',
  Tweets_Per_Day: 'Tweets Per Day',
  Number_of_conversations: ' Num of conversations',
  delete: 'delete',
  tweet_calendar: 'tweet calendar',
  instagram_calender: 'instagram calender',
  none: 'none',
  must_fill_first_field: 'you must fill the first field at least',
  must_fill_second_field: 'you must fill the second field at least',
  must_fill_this_field: 'you must fill this field at least',
  must_fill_field: 'you must fill this field',
  parent_has_sub_category:
    "the selected parents (items) can't be attached to another parent, as one of them has subcategories",
  one_parent_has_sub_category:
    'This parent can’t be attached to another as it has subcategories',
  search_parentCategory: 'search parent category',
  joined_on: 'joined on',
  search_tweets: 'Search Tweets',
  search_by_tweets: 'search by tweets',
  tweets_contain_word: 'Tweets contain word',
  articles_contain_word: 'Articles contain word',
  list_of_images_and_videos: 'A list of images ',
  views: 'views',
  up_to_date: 'Up To Date',
  influencerCategory: 'influencers/category',
  type: 'Type',
  media: 'Media',
  account: 'Account',
  account_type: 'Account type',
  last_tweet: 'Last Tweet',
  number_of_conversations: 'number of conversations',
  UNANALYZED: 'UNANALYZED',
  ANALYZED: 'ANALYZED',
  we_are_retrieving_your_translated_mentions:
    'we are retrieving your translated mentions',
  we_are_retrieving_your_translated_posts:
    'we are retrieving your translated posts',
  we_are_retrieving_your_translated_articles:
    'we are retrieving your translated articles',
  we_are_retrieving_your_translated_posts_insta:
    'we are retrieving your translated posts',
  we_are_retrieving_your_translated_tiktok:
    'we are retrieving your translated posts',
  established_on: 'Established on',
  articles: 'Articles',
  start_year: 'start year',
  authorinfo: 'Author Info',
  gained_subscribers: 'Gained subscribers',
  channel_total_views: 'Channel Total views',
  channel: 'Channel ',
  recentimgaes: 'Recent Images',
  added_influencer: ' added successfully ',
  waiting_to_grab_videos: 'waiting to grab videos',
  this_influencer_entityIs_trashed:
    'This Influencer/Entity is trashed, Do you want to restore it?',
  stateless: 'State Less',
  has_nationality: 'Has Nationality',
  nationality_status: 'Nationality Status',
  please_enter_start_date: 'please enter start date',
  tweet_classification: 'Tweets Classification',
  tweets_type: 'Tweets Type',
  filter_by: 'Filter By',
  original_tweets: 'Original tweets',
  gender_was_added_by_system: 'Gender was added by system',
  system_is_unable_to_identify_the_gender_because_name_is_not_clear:
    'System is unable to identify the gender because name is not clear',
  name_validation_min: 'Name field must be at least one char',
  key_validation_min: 'Key field must be at least one char',
  link_validation_min: 'social link must be at least two chars',
  full_grab_warning:
    'Warning: this is a basic data, to get all profile data you need to regrab the influencer',
  items_to_group: 'Items to Group',
  group_details: 'group details',
  tweets_by_language: 'tweets by language',
  number_of_mentions: 'number of mentions',
  convert_Inf:
    "Are you Sure you want to convert this influencer to an entity ? The following info if exists won't be converted        -Personal data(DOF ,Gender,..) -Educational information -work experiences",
  convert_entity:
    "Are you Sure you want to convert this entity to an influencer ? The following info if exists won't be converted         -Entity information(Established on ,activity type)  -contact info ",
  incomplete: 'incomplete',
  added_success:
    'added successfully ,we will send you a notification after grabbing all information',
  you_can_not_delete: `you con't delete in progress influencers `,
  edit_success:
    'edited successfully ,we will send you a notification after grabbing all information',
  last_tweet_client: 'last tweet client',
  last_tweet_per_day: 'last tweet',
  day_ago: 'day ago',
  days_ago: 'days ago',
  two_day_ago: '2 day ago',
  less_than_day: 'less than 1 day',
  days: 'days',
  ago: 'ago',
  inf_followers: 'influencer followers',
  inf_following: 'influencer following',
  most_liked: 'most liked',
  search_by_tweet_content: 'search by tweet content',
  search_by_post_content: 'search by post content',
  search_by_video_content: 'search by video content',
  search_by_article_content: 'search by article content',
  work_place: 'Contact Information',
  day: 'day',
  time_frame: 'timeFrame',
  tweets_media: 'Tweets Media',
  convert_failed_report:
    "Sorry, you can't convert this influencer to entity as it has detailed report created",
  convert_failed_linkedin:
    "Sorry, you can't convert this influencer to entity as it has linkedin account created",
  convert_failed_linkedin_entity:
    "Sorry, you can't convert this  entity to influencer as it has linkedin account created",
  convert_failed_author:
    "Sorry, you can't convert this influencer to entity as it's attached to an author",
  convert_failed_source:
    "Sorry, you can't convert this entity to influencer as it's attached to a source",
  keys_should_be_unique: 'key should be unique',
  skill_should_be_unique: 'Skill should be unique',
  total_entities: 'total entities',
  top_mentions: 'top mentions',
  most_mentioned: 'top mentioned',
  top_words: 'top words',
  top_tagged: 'top tagged',
  influencer_sentiment_analysis: 'influencer sentiment analysis',
  frequent_hashtags: 'frequent hashtags',
  location_history: 'Location History',
  reach: 'reach',
  impression: 'impression',
  posts_count: 'total posts',
  instagram_posts_count: 'Total Instagram Posts',
  linked_in_posts_count: 'Total LinkedIn posts',
  linked_in_posts: 'LinkedIn Posts',
  top_geo_loactions: 'top geo locations',
  grab_old_tweets: 'grab old tweets',
  first_link_required: 'You Must Add this Link First',
  influencers_details: 'influencers details',
  last_mentioned_on: 'Last mentioned on',
  friend: 'Friend',
  friends: 'Friends',
  relatives: 'Relatives',
  please_select_relation_type: 'Please Select The Relation Type',
  relation_type: 'Relation Type',
  relation: 'Relation',
  influencer_relation: 'Influencer Relation',
  coworkers: 'Coworkers',
  entity_div: 'Entity Division',
  entity_org: 'Entity Organization',
  regrab_before_download: 'regrab before download',
  checking_report_time:
    'Checking this ,the report might take up to 30 mins to finish.',
  Add_another_address_number: '+ Add another address',
  profile: 'profile',
  issuing_organization: 'issuing organization',
  issue_date: 'issue date',
  month: 'month',
  year: 'year',
  expiration_date: 'expiration date',
  credential_id: 'credential id',
  credential_url: 'credential url',
  Add_another_license_section: 'Add another license & Certifications section',
  number: 'number',
  Add_another_course_section: 'Add another Course section',
  licenses_certifications_courses:
    'Licenses, Certifications, & Courses  information ',
  licenses_certifications: 'Licenses And Certifications',
  courses: 'Courses',
  information: 'Information',
  search_by_degree: 'search by degree',
  grade: 'grade',
  fellow_students: 'Fellow Students',
  recent_activity_time: 'recent activity time',
  recent_post: 'recent post',
  posts_classification: 'posts classification',
  posts_by_language: 'posts by language',
  top_people: 'top people in conversation with',
  influencer_id: 'influencer ID',
  Number_of_comments: 'No. of comments',
  comments: 'comments',
  posts: 'posts',
  insightful: 'insightful',
  support: 'support',
  celebrate: 'celebrate',
  love: 'love',
  like: 'like',
  media_types: 'media types',
  posts_calendar: 'posts calendar',
  post: 'post',
  instagram_posts: 'instagram posts',
  linkedin_posts:'linkedin posts',
  classification: 'posts classifications',
  most_celebrated: 'most celebrated',
  most_supported: 'most supported',
  most_loved: 'most loved',
  most_insightful: 'most founded insightful',
  reposts: 'reposts',
  num_of_comment: 'num of comments',
  last_comment_on: 'last comment on',
  linkedin_calendar: 'Posts Calendar',
  employment_type: 'employment type',
  grabbing_method: 'grabbing method',
  conversation_on: 'conversation on',
  conversation: 'conversation',
  we_are_retrieving_your_translated_tweets:
    'we are retrieving your translated tweets',
  we_are_retrieving_your_translated_comments:
    'we are retrieving your translated comments',
  we_are_retrieving_your_translated_videos:
    'we are retrieving your translated videos',
  we_are_retrieving_your_translated_replies:
    'we are retrieving your translated replies',
  we_are_retrieving_your_translated_quotes:
    'we are retrieving your translated quotes',
  replies: 'replies',
  conversation_with: 'conversation with',
  open_in_linkedin: 'open in linkedin',
  open_in_instagram: 'open in instagram',
  minute_ago: 'minute ago',
  two_minute_ago: 'two minute ago',
  minutes_ago: 'minutes ago',
  minute: 'minute',
  minutes: 'minutes',
  this_organization_trashed:
    'This organization is trashed, do you want to restore it?',
  this_profile_is_regrab:
    'This profile is already grabbed, do you still want to force regrab?',
  force_regrab: 'force regrab',
  select_profile_you_want_regrab: 'Select Profiles you want to regrab',
  select_all: 'Select All',
  this_profile_is_regrab_already:
    'This profile is already re-grabbed, to force regrab click the regrab icon on the profile itself',
  regrab: 'Regrab',
  by_degree: 'search by degree',
  work_experiences: 'work experiences',
  educations: 'education',
  translate: 'Translate',
  max_5_tags: 'Max 5 tags',
  search_by_tags: 'search by tags',
  gallery: 'gallery',
  open_in_tiktok: 'open in tiktok',
  top_hashtags: 'top hashtags',
  diggs: 'diggs',
  video_language: 'videos language',
  tiktok_posts_count: 'total tiktok videos',
  tiktok_videos: 'tiktok videos',
  num_plays: 'no.of plays',
  shares: 'shares',
  plays: 'plays',
  downloads: 'downloads',
  bookmarks: 'Bookmark',
  search_by_video_caption: 'search by video caption',
  most_play: 'Most Played',
  top_Account: 'Top account videos',
  top_tags: 'Frequent Used Tags',
};

export const ar = {
  top_tags: 'الوسوم الأكثر إستخداماً',
  top_Account: 'أهم فيديوهات الحساب',
  most_play: 'الأكثر تشغيلاً',
  search_by_video_caption: 'ابحث بمحتوي الفيديو',
  bookmarks: 'العلامات المرجعيه',
  shares: 'مشاركات',
  plays: 'التشغيل',
  downloads: 'التحميلات',
  num_plays: 'عدد تشغيل الفيديوهات',
  tiktok_videos: 'فيديوهات التيك توك',
  tiktok_posts_count: 'إجمالي فيديوهات التيك توك',
  video_language: 'لغه الفيديوهات',
  diggs: 'الفيديوهات المُحببه',
  top_hashtags: 'أعلي الهاشتاقات',
  open_in_tiktok: 'افتح في تيك توك',
  gallery: 'المعرض',
  translate: ' مُترجم',
  educations: 'بيانات التعليم',
  work_experiences: 'خبرات العمل',
  by_degree: 'ابحث بواسطه الدرجه',
  regrab: 'جلب',
  this_profile_is_regrab_already:
    'قد تم جلب بيانات هذا الحساب بالفعل, لإعادة الجلب قم بالضغط على إعادة الجلب فى صفحة هذا الحساب',
  select_all: 'اختر الكل',
  select_profile_you_want_regrab: 'حدد الملفات الشخصية التي تريد إعادة جلبها',
  this_profile_is_regrab:
    'لقد تم جلب بيانات هذا الحساب بالفعل, هل تريد إعادة الجلب الآن؟',
  force_regrab: 'إعاده الجلب',
  this_organization_trashed: 'تم حذف هذه المؤسسة, هل تود إستعادتها؟',
  minute_ago: 'منذ دقيقه',
  two_minute_ago: 'منذ دقيقتين',
  add_skill: 'إضافة مهارة',
  search_by_skill: ' البحث بأسم المهارة',
  minute: 'دقيقه',
  note:'ملاحظة',
  fellow_students: 'زملاء الدراسة',
  minutes: 'دقائق',
  open_in_linkedin: 'افتح في لينكدان',
  open_in_instagram: 'افتح في انستقرام',
  media_types: 'أنواع الوسائط',
  replies: 'الردود',
  conversation_with: 'في محادثه مع',
  start_year: 'سنة البدء',
  conversation_on: 'تم المحادثه في',
  conversation: 'المحادثة',
  comments: 'تعليقات',
  employment_type: 'نوع الوظيفة',
  grabbing_method: 'طريقة الجلب',
  linkedin_calendar: 'تقويم المنشورات',
  num_of_comment: 'عدد التعليقات',
  last_comment_on: 'التعليق الاخير',
  reposts: 'اعاده النشر',
  most_celebrated: 'الأكثر إحتفالا',
  most_supported: 'الأكثر دعما',
  most_loved: 'الأكثر حبا',
  most_insightful: 'الاكثر حكمة',
  classification: 'أنواع المنشورات',
  post: 'المنشور',
  recent_activity_time: 'وقت النشاط الأخير',
  recent_post: 'المنشور الأخير',
  posts_classification: 'تصنيف المشاركات',
  posts_by_language: 'المشاركات حسب اللغة',
  top_tagged: 'الاكثر وسماً',
  top_people: 'أهم الأشخاص في المحادثة معهم',
  influencer_id: 'مُعرف المؤثر',
  Number_of_comments: 'عدد التعليقات',
  posts: 'المنشورات ',
  insightful: 'وجد المنشورات مفيده',
  support: 'دعم المنشورات',
  celebrate: 'أحتفل بالمنشورات',
  love: 'أحب المنشورات',
  like: 'أعجب بالمنشورات',
  grade: 'درجة',
  posts_calendar: 'تقويم المشاركات',
  search_by_degree: 'البحث حسب الدرجة',
  issuing_organization: 'منظمة الإصدار',
  issue_date: 'تاريخ الإصدار',
  month: 'الشهر',
  year: 'السنه',
  expiration_date: 'تاريخ انتهاء الصلاحية',
  credential_id: 'مُعرف الاعتماد',
  credential_url: 'عنوان URL لبيانات الاعتماد',
  Add_another_license_section: 'إضافة قسم آخر للتراخيص والشهادات',
  number: 'الرقم',
  Add_another_course_section: 'إضافة قسم دورة آخر',
  licenses_certifications_courses: 'التراخيص والشهادات ومعلومات الدورات ',
  licenses_certifications: 'التراخيص والشهادات',
  courses: 'الدورات',
  information: 'معلومات',
  Add_another_address_number: '+ إضافة  عنوان اخر',
  Add_another_business_address_number: '+اضافة عنوان عمل اخر',
  checking_report_time: 'عند إختيار هذا, يمكن للتقرير ان يأخذ حتي 30 دقيقة',
  regrab_before_download: 'إعادة المزامنه قبل التحميل',
  entity_div: 'شعبه الكيان',
  entity_org: 'مؤسسه الكيان',
  coworkers: 'زملاء عمل',
  last_mentioned_on: 'اخر اشارة في',
  influencers_details: 'تفاصيل المؤثر',
  influencer_relation: 'صلة المؤثر',
  relation_type: 'نوع الصلة',
  relation: 'الصلة',
  please_select_relation_type: 'برجاء تحديد نوع الصلة',
  friend: 'صديق',
  friends: 'اصدقاء',
  relatives: 'اقارب',
  first_link_required: 'يجب اضافه هذا الرابط اولاً',
  grab_old_tweets: 'مزامنه التغريدات القديمة',
  impression: 'الانطباع',
  reach: 'الوصول',
  top_words: 'اعلي الكلمات',
  top_geo_loactions: 'أعلي المواقع الجغرافية',
  frequent_hashtags: 'الهاشتاقات الأكثر تكراراً',
  influencer_sentiment_analysis: 'تحليل نسب الاراء للمؤثر ',
  tweets_media: 'وسائط التغريدات',
  convert_failed_report: 'عفوا, هذا المؤثر لديه تقرير مفصل تم إنشائه من قبل',
  convert_failed_linkedin: 'عفوا, هذا المؤثر لديه موقع علي لينكدان    ',
  convert_failed_linkedin_entity: 'عفوا, هذا الكيان لديه موقع علي لينكدان    ',
  convert_failed_author: 'عفوا, هذا المؤثر تم ربطه بكاتب رأي  من قبل',
  convert_failed_source: 'عفوا, هذا الكيان تم ربطه بمصدر من قبل',
  top_mentions: 'أعلي الإشارات',
  most_mentioned: 'الأكثر إشارة',
  keys_should_be_unique: ' المفتاح يجب ان يكون غير متكرر',
  skill_should_be_unique: 'هذه المهارة مكررة',
  unique_phone_number: 'رقم الهاتف يجب ان يكون غير متكرر',
  unique_address: 'العنوان يجب ان يكون غير متكرر',
  unique_email: 'البريد الالكتروني يجب ان يكون غير متكرر',
  unique_website: 'الموقع يجب ان يكون غير متكرر',
  total_entities: ' اجمالي الكيانات',
  time_frame: 'إطار زمني',
  day: 'يوم',
  work_place: 'بيانات التواصل',
  search_by_tweet_content: 'ابحث بمحتوي التغريده',
  search_by_post_content: 'ابحث بمحتوي المنشور',
  search_by_video_content: 'ابحث بمحتوي الفيديو',
  location_history: 'تاريخ الموقع الجغرافي',

  search_by_article_content: 'ابحث بمحتوي المقاله',
  most_liked: 'الأكثر اعجاب',
  day_ago: 'منذ يوم',
  days: 'أيام',
  ago: 'منذ',
  two_day_ago: 'منذ يومين',
  less_than_day: 'أقل من يوم',
  last_tweet_per_day: 'آخر تغريدة ',
  last_tweet_client: 'اخر حساب مستخدم',
  you_can_not_delete: 'لا يمكنك حذف المؤثرين قيد الجلب نهائيا',
  added_success: 'تمت الإضافه, سيصلك إشعار عند جلب البيانات',
  edit_success: 'تم التعديل, سيصلك إشعار عند جلب البيانات',
  incomplete: 'غير مُكتمل',
  number_of_mentions: 'عدد الإشارات',
  tweets_by_language: 'التغريدات حسب اللغة',
  group_details: 'تفاصيل المجموعه',
  items_to_group: 'عناصر المجموعه',
  name_validation_min: 'الاسم لا يجب ان يقل عن حرف  ',
  link_validation_min: 'هذا الرابط لا يجب ان يقل عن حرفين',
  key_validation_min: 'هذا الحقل لا يجب ان يقل عن حرف  ',
  contact_info: 'بيانات التواصل',
  please_enter_start_date: 'ادخل التاريخ من فضلك',
  waiting_to_grab_videos: 'يتم جمع الفيديوهات',
  added_influencer: ' تمت الإضافه بنجاح',
  channel: 'القناة',
  business_address: 'عنوان العمل',
  gained_subscribers: 'المُتابِعون المكتسبون ',
  channel_total_views: 'مجموع مشاهدات القناة',
  we_are_retrieving_your_translated_mentions:
    '    يتم استرجاع الإشارات المترجمه الان',
  we_are_retrieving_your_translated_comments:
    '    يتم استرجاع التعليقات المترجمه الان',
  we_are_retrieving_your_translated_articles:
    'يتم استرجاع المقالات المترجمه الان',
  we_are_retrieving_your_translated_posts:
    '    يتم استرجاع المنشورات المترجمه الان',
  we_are_retrieving_your_translated_posts_insta:
    '    يتم استرجاع المنشورات المترجمه الان',
  we_are_retrieving_your_translated_tiktok:
    '    يتم استرجاع المنشورات المترجمه الان',
  ANALYZED: 'محلل',
  UNANALYZED: 'غير محلل',
  number_of_conversations: 'عدد المحادثات',
  influencerCategory: 'المؤثرون / الفئه',
  business_phone_number: 'رقم تليفون العمل',
  last_post: 'اخر منشور',
  must_fill_field: 'يجب ملئ هذا حقل قبل إضافة عنصر جديد',
  must_fill_first_field: 'يجب ملئ أول حقل قبل إضافة عنصر جديد',
  must_fill_second_field: 'يجب ملئ ثاني حقل قبل إضافة عنصر جديد',
  must_fill_this_field: 'يجب ملئ هذا حقل قبل إضافة عنصر جديد',
  delete: 'حذف نهائي',
  unanalyzed_influencers_details: ' تفاصيل المؤثر الغير محلل',
  continue: 'استمر',
  Number_of_conversations: 'عدد المحادثات',
  Tweets_Per_Day: 'متوسط التغريدات في اليوم',
  Most_active_time: 'الوقت الأكثر نشاطًا',
  average_interval_between_tweets: 'متوسط الفاصل الزمني بين التغريدات',
  Tweets: 'التغريدات',
  Following: 'المُتابَعين',
  Followers: 'المُتابِعين',
  recent_media: '  أحدث الصور و الفيديوهات',
  Related_Hashtags: 'الهاشتقات ذات صلة',
  Posts_per_day: 'المشاركات في اليوم',
  posts_types: 'انواع المنشورات',
  Videos_calendar: 'تقويم مقاطع الفيديو',
  Talking_About: 'نتحدث عن',
  posts: 'المنشورات',
  likes: 'اعجاب',
  Created_date: 'تاريخ الإنشاء',
  continue: 'استمر',
  nationality: 'الجنسية',
  graduation_year: 'سنة التخرُج',
  see_more: 'عرض المزيد',
  see_less: 'عرض القليل',
  instagram_posts: 'منشورات انستقرام',
  linkedin_posts: 'منشورات لينكد ان',
  posts_count: 'إجمالى المنشورات',
  hiding_followers:'هذا المؤثر يخفي لائحة متابيعنه',
  hiding_followings:'هذا المؤثر يخفي لائحة متابعهم',
  instagram_posts_count: 'إجمالى منشورات انستقرام',
  linked_in_posts_count: 'إجمالى منشورات لينكد ان',
  linked_in_posts: 'منشورات لينكد ان',
  added_successfully: 'تم إضافة المؤثر بنجاح',
  edited_successfully: 'تم تعديل المؤثر بنجاح',
  frequent_used_hashtags: ' الهاشتاقات الأكثر إستخداماً',
  top_people_in_conversation: 'الأشخاص  الأكثر تفاعلا',
  people_in_conversation: 'الأشخاص  في المحادثة',
  tweets: 'التغريدات',
  tweet_types: 'أنواع التغريدات',
  category_subcategory: 'الفئة / الفئات الفرعية',
  top_category_subcategory: 'أعلى الفئات الفرعية/الفئة',
  influencers_table: 'جدول المؤثرين',
  gained_followers: 'المُتابِعون الجدد',
  trashed_on: 'مسح في',
  subscribers: 'الُمتابعون',
  tweet_clients: 'الحسابات المستخدمه فى التغريد',
  searchBy_influencersTitle: 'بحث بعنوان الموثرين',
  edit_group: 'تعديل مجموعة',
  edit_category: 'تعديل الفئه',
  category: 'الفئه',
  search_by_category: 'البحث  بالفئة',
  search_by_influencer: 'بحث بإسم المؤثر',
  are_you_sure_you_want_to_cancel: 'هل أنت متأكد أنك تريد إلغاء ؟',
  attach_influnecer: 'تعليق المؤثر',
  grouping_table_here: 'جدول التجميع هنا',
  Videos_Archive: 'أرشيف الفيديو',
  Parent_Category: 'القسم الرئيسي',
  Catrgory_Name: 'اسم الفئه',
  Add_image: 'إضافة صوره ',
  key: 'مفتاح',
  value: 'قيمة',
  Add_field: 'إضافة حقل',
  Add_another_partnership_section: 'إضافة قسم شراكة آخر',
  Partnership_name: 'اسم الشراكة',
  At_least_one_field_is_to_be_filled: 'يجب ملء حقل واحد على الأقل',
  At_least_one_field_filled: 'يجب ملء حقل واحد على الأقل',
  Add_another_work_section: '+ إضافة قسم عمل آخر ',
  date: 'التاريخ',
  workplace: 'مكان العمل',
  from: 'من',
  to: 'إلى',
  office_fax_number: 'رقم فاكس المكتب',
  office_address: 'عنوان المكتب',
  office_email: 'البريد الإلكتروني للمكتب',
  business_email: 'بريد إلكترونى العمل',
  Add_another_contact_section: ' + إضافة قسم اتصال آخر',
  office_phone_number: 'تليفون المكتب',
  Add_another_college_section: '+ أضف قسم اخر للكليه',
  Add_another_school_section: '+ أضف قسم آخر للمدرسة ',
  trash: 'حذف ',
  school: 'المدرسه',
  school_university: 'المدرسة/الجامعة',
  Graduation_date: 'تاريخ التخرُج',
  University: 'الجامعه',
  faculty: 'كلية',
  major: 'القسم الرئيسي',
  Graduation_date: 'تاريخ التخرُج',
  description: 'الوصف',
  degree: 'الدرجة العلمية',
  website: 'موقع الكتروني',
  websites: 'مواقع الكترونية',
  Average_paid: 'متوسط المدفوع',
  Religion: 'ديانه',
  Social_Status: 'الحالة الإجتماعية',
  gender: 'النوع',
  personal_address: 'العنوان الشخصي',
  Add_another_phone_number: '+ إضافة رقم تليفون اخر',
  Add_another_email: '+ إضافة بريد الكتروني اخر',
  Add_another_business_email: '+ إضافة بريد الكتروني للعمل اخر',
  phone_number: 'رقم تليفون',
  single: 'أعزب',
  divorced: 'مطلق',
  complicated: 'معقد',
  relationship: 'في علاقه',
  married: 'متزوج',
  male: 'ذكر',
  female: 'انثي',
  bio: ' السيرة الذاتية ',
  change_picture: 'تغيير الصورة',
  age_group: 'الفئة العمرية',
  date_of_birth: 'تاريخ الميلاد',
  nickname: 'اسم الشهره',
  influencer_name: 'اسم المؤثر',
  platforms: 'المنصات',
  edit_dashboard: 'تعديل القائمة الرئيسية',
  top_influencers: 'أعلى المؤثرين',
  influencer_no_tweets: 'لا يوجد المزيد من التغريدات. ',
  no_posts: 'لا يوجد المزيد من المنشورات. ',
  no_articles: 'لا يوجد المزيد من المنشورات. ',
  influencer_no_videos: 'لا يوجد المزيد من الفيديوهات. ',
  influencer_no_posts_insta: 'لا يوجد المزيد من المنشورات',
  influencer_no_posts: 'لا يوجد المزيد من المنشورات',
  influencer_no_comments: 'لا يوجد المزيد من التعليقات',
  influencer_no_tiktok: 'لا يوجد المزيد من الفيديوهات',
  add_new_influencer: 'إضافة مؤثر جديد',
  edit_influencer: 'تعديل المؤثر',
  are_you_sure_you_want_to_cancel_edit_influencer:
    'هل انت متأكد انك تريد الغاء تعديل  المؤثر؟',
  are_you_sure_you_want_to_cancel_add_group:
    'هل انت متأكد انك تريد الغاء إضافة  المجموعة؟',
  full_grab_warning:
    'تحذير : هذا الحساب يظهر فقط البيانات الأساسية, لظهور جميع بيانات الحساب يرجى الضغط على زر الجلب لهذا الحساب',
  are_you_sure_you_want_to_cancel_edit_group:
    'هل انت متأكد انك تريد الغاء تعديل  المجموعة؟',
  are_you_sure_you_want_to_cancel_edit_catgory:
    'هل انت متأكد انك تريد الغاء تعديل  الفئة؟',
  are_you_sure_you_want_to_cancel_add_influencer:
    'هل انت متأكد انك تريد الغاء إضافة المؤثر؟',
  group_info: 'بيانات المجموعة',
  attach_influencers: 'إضافة مؤثرين',
  attach_categories: 'إضافة فئة',
  category_info: 'بيانات الفئة',
  add_new_category: 'إضافة فئة جديد',
  partnerships: 'الشراكة',
  additional_info: 'بيانات إضافية',
  work_experience: 'جهات العمل',

  social_links: 'روابط التواصل الإجتماعي',
  personal_photos: 'الصور الشخصية',
  total_followers: 'إجمالي المُتابِعين',
  general_info: 'بيانات عامة',
  inf_followers: 'مُتابِعين المؤثر',
  inf_following: 'مُتابَعين المؤثر',
  general_skills: 'المهارات العامة',
  channel_sub: 'مشتركو القناة',
  Add_another_website: 'إضافة موقع إلكترونى آخر',
  uploaded_vid: 'الفيديوهات المُحمّلة',
  total_videos_view: 'إجمالي مشاهدات الفيديو',
  extra_info: 'بيانات إضافية',
  work_info: 'بيانات العمل',
  workplace: 'مكان العمل',
  position: 'الوظيفه',
  start_date: 'تاريخ البدء',
  end_date: 'تاريخ الانتهاء',
  social_profile_urls: 'روابط الملف الشخصي',
  partnership_info: 'بيانات الشراكة',
  in_part_with: 'في شراكة مع',
  name: 'الاسم',
  nickname: 'اسم الشهره',
  age: 'العمر',
  new_influencers: 'المؤثرون الجُدد',
  country: 'الدولة',
  personal_info: 'بيانات شخصية',
  gender: 'الجنس',
  social_status: 'الحالة الإجتماعية',
  religion: 'الديانة',
  address: 'العنوان',
  email: 'البريد الإلكتروني',
  emails: 'البريد الألكتروني',
  phone_numbers: 'أرقام الهاتف',
  phone_number_error: 'يجب ملئ الحقل في نطاق ما بين 9-15 رقم ',
  avg_paid: 'متوسط الدخل',
  still_working_there: ' ما زال يعمل إلى الان ',
  unique_name: 'اسم المؤثر مستخدم بالفعل.ادخل اسم جديد',
  unique_link: 'رابط التواصل الإجتماعي غير قابل للتكرار',
  good_friends: 'الاصداقاء المقربون',
  educational_info: 'بيانات تعليمية',
  school: 'المدرسة',
  university: 'الجامعة',

  grad_year: 'سنة التخرُج',
  total_influencers: 'إجمالي المؤثرين',
  most_popular_videos: 'الفيديوهات الأكثر شُهرة',
  most_popular_posts: 'المنشورات الأكثر شُهرة',
  most_popular_tweets: 'التغريدات المشهورة في',
  analyzed_influencers: 'المؤثرون المحللون',
  un_analyzed_influencers: 'المؤثرون غير المحللين',
  subcategory: 'الفئة الفرعية',
  total_subca: 'إجمالي الفئات الفرعية',
  total_categories: 'إجمالي الفئات',
  total_tweets: 'إجمالي التغريدات',
  total_groups: 'إجمالي المجموعات',
  influencerGroup: 'المؤثرون / المجموعة',
  influencer_category: 'فئة المؤثر',
  influencer_platform: 'المؤثرون / المنصة',
  influencer_age_group: 'الفئة العمرية للمؤثرين',
  Top_5_trending_influencers: 'أعلى 5 مؤثرين ترند',
  influencers_gender: 'جنس المؤثرين',
  categories: 'الفئات',
  influencers: 'المؤثرون',
  achieved: 'انجزت',
  tweets: 'التغريدات',
  groups: 'المجموعات',
  inf_groups: 'مجموعات المؤثرين',
  inf_category: 'فئات المؤثرين',
  influencers_map: 'خريطة المؤثرين',
  new_influencer: 'مؤثر جديد',
  grabbed_on: ' تم الجلب في',
  group_name: 'اسم المجموعة',
  description: 'الوصف',
  num_influencers: 'عدد المؤثرين',
  num_entities: 'عدد الكيانات',
  num_subCategories: 'عدد الفئات الفرعية',
  slug: 'اسم المفتاح',
  created_group: 'المجموعات المنشأة',
  influencers_group: 'مجموعات المؤثرين',
  add_new_group: 'إضافة مجموعة جديدة',
  created_categories: 'الفئات المنشأة',
  Subcategory_category: 'الفئات الفرعية / الفئات',
  category_name: 'اسم الفئة',
  analyzed_influencers_details: 'تفاصيل المؤثر المحلل',
  searchBy_influencerTitle: 'بحث بإسم المؤثر',
  created_date: 'تاريخ الإنشاء',
  channel_subscribers: 'مُتابعي القناة',
  analyzed_category_to_influencer: 'المؤثرون المحللون في الفئة',
  analyzed_group_to_influencer: 'المؤثرون المحللون في المجموعة',

  total_views: 'إجمالي مشاهدات الفيديوهات',
  views_per_day: 'المشاهدات اليومية',
  channel_watch_time: 'وقت مشاهدة القناة',
  videos_calendar: 'تقويم الفيديوهات',
  future_subscribers: 'الُمتابعون المستقبليون',
  related_hashtags: 'الهاشتاقات ذات الصلة',
  similar_hashtags: 'الهاشتاقات المتشابة',
  future_views: 'المشاهدات المستقبلية',
  channel_top_videos: 'أعلى فيديوهات القناة',
  related_influencers: 'مؤثرون ذو صلة',
  related_channels: 'قنوات ذات صلة',
  similar_channels: 'قنوات مُتشابهه',
  similar_accounts: 'الحسابات المشابهة',
  related_groups: 'مجموعات ذات صلة',
  trending_hash_group: 'الهاشتاقات الأكثر تداولآ في المجموعة',
  trending_hash_category: 'الهاشتاقات الأكثر تداولآ في التصنيف',
  category_added_success: 'تم إضافة فئة بنجاح',
  category_edited_success: 'تم تعديل الفئة بنجاح',
  group_added_success: 'تم إضافة المجموعة بنجاح',
  group_edited_success: 'تم تعديل المجموعة بنجاح',
  edits_done_success: 'التعديلات تمت بنجاح',
  influencer_group: 'مجموعة المؤثر',
  influencer_category_modal: 'فئة المؤثر',
  exist_inf: 'مؤثر موجود بالفعل',
  new_inf: 'مؤثر  جديد',
  merge_inf: 'قم باختيار المؤثر الذي تود الدمج خلاله',
  select_inf: 'قم بإختيار المؤثر الموجود بالفعل',
  select_new_inf: 'قم بإختيار المؤثر الرئيسي لجلب الاسم والصوره منه',
  assign_new_parent:
    'هل انت متأكد انك تريد إضافة فئه رئيسيه جديدة؟ حيث ان الفئات التي تملك فئه رئيسيه سوف تضاف إلى فئه رئيسيه جديدة ',
  select_the_parent: 'اختر الفئه الرئيسية',
  search_parent: 'بحث عن فئه رئيسيه',
  search_inf: 'بحث عن  مؤثر',
  we_are_retrieving_your_translated_tweets:
    'يتم استرجاع التغريدات المترجمه الان',
  we_are_retrieving_your_translated_videos:
    'يتم استرجاع الفيديوهات المترجمه الان',
  we_are_retrieving_your_translated_replies: 'يتم استرجاع الردود المترجمه الان',
  we_are_retrieving_your_translated_quotes:
    'يتم استرجاع الإقتباسات المترجمه الان',
  videos: 'الفيديوهات',
  Videos_calendar: 'نتيجة الفيديوهات',
  merge_err: 'يوجد أكثر من لينك تواصل اجتماعي مشترك ما بين المؤثرين',
  analyze: 'التحليل',
  achievements: 'الانجازات',
  Up_to_Date: 'حتى تاريخه',
  today: 'اليوم',
  By_Month: 'بالشهر',
  Popular: 'الشائع',
  Featuring: 'المتميز',
  Featured_by: 'يتميز ب',
  in_progress: 'في تقدم',
  completed: 'تم',
  archived: 'ارشيف',
  uploaded_video: 'الفيديوهات المُحمّلة',
  video_archive: 'ارشيف الفيديوهات',
  user: 'المستخدم',
  views: 'المشاهدات',
  offic_fax_numb: 'رقم فاكس الشركة',
  offic_phone_num: 'رقم هاتف الشركة',
  tweet_calendar: 'تقويم التغريدات',
  instagram_calender: 'تقويم المنشورات',
  none: 'لا يوجد',
  parent_has_sub_category:
    'لا يمكن ارفاق الفئات المختاره إلى فئه رئيسيه لان احدهما تمتلك فئات فرعية',
  one_parent_has_sub_category:
    'لا يمكن ارفاق الفئه المختاره إلى فئه رئيسيه لانها تمتلك فئات فرعية',
  search_parentCategory: 'بحث بالفئة الرئيسية',
  are_you_sure_you_want_to_cancel_add_category:
    'هل انت متاكد انك تريد الغاء أنشاء الفئة؟',
  are_you_sure_you_want_to_cancel_edit_category:
    'هل انت متاكد انك تريد الغاء تعديل الفئة؟',
  joined_on: 'التحق في',
  search_tweets: 'البحث في التغريدات',
  search_by_tweets: 'بحث في التغريدات',
  tweets_contain_word: 'تغريدات تحتوي على كلمة',
  articles_contain_word: ' مقالات تحتوي على كلمة ',
  list_of_images_and_videos: 'قائمة الصور ',
  views: 'مشاهدات',
  up_to_date: 'حتى الآن',
  mentions: 'اشارات',
  hashtag: 'الهاشتاقات',
  type: 'النوع',
  media: 'الوسائل المتعدده',
  account: 'الحساب',
  account_type: 'نوع الحساب',
  last_tweet: 'آخر تغريدة',
  established_on: 'تأسس فى',
  articles: 'المقالات',
  authorinfo: 'معلومات كاتب الرأي',
  recentimgaes: 'أحدث الصور',
  search_by_title: 'البحث بالعنوان',
  waiting_to_grab_videos: 'في انتظار جلب مقاطع الفيديو',
  this_influencer_entityIs_trashed:
    'هذا المؤثر/الكيان تم حذفه ، هل تريد استعادته؟',
  stateless: 'غير مجنس',
  has_nationality: 'لديه جنسيه',
  nationality_status: 'حالة الجنسية',
  tweet_classification: 'التغريدات و اعاده التغريد ',
  tweets_type: 'انواع التغريدات',
  filter_by: 'التنقيه بواسطه',
  original_tweets: 'التغريدات',
  gender_was_added_by_system: 'تمت إضافة النوع بواسطة النظام',
  system_is_unable_to_identify_the_gender_because_name_is_not_clear:
    'النظام غير قادر على تحديد النوع لأن الاسم غير واضح',
  influencer_importance: 'اهميه المؤثر',
  entity_importance: 'اهميه الكيان',
  convert_Inf:
    'هل انت متاكد انك تريد تحويل هذا المؤثر الي كيان ؟  بعض المعلومات التاليه لن يتم تحويلها -المعلومات الشخصيه -المعلومات التعليميه ',
  convert_entity:
    '  هل انت متاكد انك تريد تحويل هذا الكيان الي مؤثر ؟  بعض المعلومات التاليه لن يتم تحويلها -معلومات الكيان -معلومات التواصل ',
  search_by_state: 'بحث بإسم المدينه',
  search_by_city: 'بحث بإسم المنطقه',
  profile: 'الصفحة الشخصية',
  max_5_tags: 'الحد الأقصى 5 وسوم',
  search_by_tags: 'بحث بواسطة الوسم',
};
